import { createSlice } from "@reduxjs/toolkit";
import { companyInformationDetails, listAllVendors, uploadMspDocument, getClientPaymentDetails, updateClientDetails, getClientDetails, getClientChecksList, postUpdatedCheckList } from "../actions/ClientManagementActions";

const clientManagementSlice = createSlice({
    name: "listAllVendors",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(listAllVendors.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(listAllVendors.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(listAllVendors.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
const getCompanyInfoSlice = createSlice({
    name: "companyInformationDetails",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(companyInformationDetails.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(companyInformationDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(companyInformationDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
const uploadMspDocumentSlice = createSlice({
    name: "uploadMspDocument",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(uploadMspDocument.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(uploadMspDocument.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(uploadMspDocument.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  const getClientPaymentDetailSlice = createSlice({
    name: "getClientPaymentDetails",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getClientPaymentDetails.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getClientPaymentDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(getClientPaymentDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
  const updateClientDetailSlice = createSlice({
    name: "updateClientDetails",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(updateClientDetails.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateClientDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(updateClientDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
  const getClientDetailSlice = createSlice({
    name: "getClientDetails",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getClientDetails.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getClientDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(getClientDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
  const getClientChecksListSlice = createSlice({
    name: "getClientChecksList",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getClientChecksList.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getClientChecksList.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(getClientChecksList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
  const postUpdatedCheckListSlice = createSlice({
    name: "postUpdatedCheckList",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(postUpdatedCheckList.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(postUpdatedCheckList.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(postUpdatedCheckList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  export const reducers = {
    listAllVendors:clientManagementSlice.reducer,
    companyInformationDetails:getCompanyInfoSlice.reducer,
    uploadMspDocument:uploadMspDocumentSlice.reducer,
    getClientPaymentDetails:getClientPaymentDetailSlice.reducer,
    updateClientDetails:updateClientDetailSlice.reducer,
    getClientDetails:getClientDetailSlice.reducer,
    getClientChecksList:getClientChecksListSlice.reducer,
    postUpdatedCheckList:postUpdatedCheckListSlice.reducer,
  }